import React from "react";
import { BaseInput } from "./base-input";

// MaskedInput.tsx

import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

const IMask = forwardRef<HTMLInputElement, any>(
  ({ onChange, name, mask, ...rest }, ref) => {
    return (
      <IMaskInput
        {...rest}
        inputRef={ref}
        mask={mask}
        overwrite
        onAccept={(value: string) =>
          onChange?.({ target: { name, value } })
        }
      />
    );
  }
);

IMask.displayName = "MaskedInput";


export const MaskedInput = (props: any) => {
    return <BaseInput {...props} as={IMask} />;
};
